import React, { Component } from 'react';
class CardholderInfoTab extends Component {
  render() {
    return <div data-testid="user-details-v2-container">Coming Soon</div>;
  }
}

export default CardholderInfoTab;
